import { useNumericParams } from '@domain-group/react-hooks'

import useReduxAction from '@hooks/useReduxAction'

import type { ModuleState } from '@redux/modules/types'

import TrainingModuleEditRoutes from './routes'

const TrainingModuleEdit = () => {
  const { trainingModuleId } = useNumericParams()

  useReduxAction(
    'trainingModules',
    'loadTrainingModule',
    {
      entityId: trainingModuleId,
    },
    [trainingModuleId],
    {
      dispatchAction: (action: Function, requestOptions) => action(trainingModuleId, requestOptions),
      shouldPerformFn: ({ loading }: ModuleState) => !!trainingModuleId && !loading,
    },
  )

  return (
    <TrainingModuleEditRoutes />
  )
}

export default TrainingModuleEdit
